export class Profile {
    sector_code: string;
    constructor(public email: string, public forename: string, public surname: string, public organisationId: string) {
    }

    get fullName(): string {
        return `${this.forename} ${this.surname}`;
    }
}
